import { Injectable } from "@angular/core";
import { PlaybackService } from "./playback";

@Injectable()
export class MediaServiceRegistry {
    private _services: PlaybackService[] = [];

    register(mediaService: PlaybackService) {
        this._services.push(mediaService);
    }

    get all() {
        return this._services.slice(0);
    }
}